export default "__VITE_ASSET__CNPZ8D9v__"